import { apiClient } from "@/api/api-client";
import { Tiptap } from "@/components/common/tiptap/Tiptap";
import BottomBar from "@/components/core/actions/bottombar";
import { Button } from "@/components/core/buttons/button";
import { Content } from "@/components/layouts/content";
import { Header } from "@/components/layouts/header";
import ArticleEditor from "@/features/dashboard/components/article-editor";
import { ArticleFormSchema } from "@/features/dashboard/types/article";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { Link } from "@tanstack/react-router";
import { toast } from "sonner";

export const Route = createFileRoute("/_dashboard/articles_/create")({
	component: RouteComponent,
});

function RouteComponent() {
	return (
		<Content pageName="New Article">
			{/*<Header title="New Article" />*/}

			<div className="flex flex-col w-full max-w-base p-6">
				<div className="mb-20">
					<ArticleEditor data={undefined} key={Date()} />
				</div>
			</div>
		</Content>
	);
}
